/*
* Salla Login Component: login popup modal
* You can use these classes to target the elements in the component.
*/
iframe {
  -moz-transition: height .3s;
  -ms-transition: height .3s;
  -o-transition: height .3s;
  -webkit-transition: height .3s;
  transition: height .3s;
  width: 100%;
}
.s-login-modal {
  &-sub-title {

  }
  &-main-btn {
    
  }
  &-main-btn-icon {

  }
  &-main-btn-text {

  }
  &-main-btn-arrow {

  }
  &-label {

  }
  &-input {

  }
  &-otp-input {

  }
  &-link {

  }
  &-error-message {

  }
  &-wrapper {

  }
  &-tab {

  }
  &-active {

  }
  &-unactive {

  }
}
